import {HeroSection} from "../components/home/HeroSection";
import {HowToUseSection} from "../components/home/HowToUseSection";
import {PurchaseCtaSection} from "../components/home/PurchaseCtaSection";
import {FaqSection} from "../components/home/FaqSection";


export const LinkToProduct = "https://www.bol.com/nl/nl/p/peesential-plastuit-voor-vrouwen-vrouwen-urinoir-urine-fles-urinaal-herbruikbaar-plastuitje-staand-plassen-plaskoker-voor-festivals-reizen-kamperen-incl-hygienisch-tasje-extensie-roze/9300000020692334"

export const openUrlInNewTab = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
};

export const HomePage = (props: any) => {
    return (
        <div className="bg-surface-100 text-surface-900 antialiased">

            <HeroSection />
            <HowToUseSection />
            <PurchaseCtaSection />
            <FaqSection />

        </div>
    );
};





